import { useState } from "react";
import { toast } from "react-toastify";
import { Plus, Trash2, Check } from "lucide-react";

import CustomButton from "@/components/desktop/button/CustomButton";

import { useDeleteIntegrationCode } from "@/hooks/histories/useIOIntegration";

import styles from "./io-sync.module.scss";

const IOExternalCodes = ({ externalCodes, selectedCode, inventoryId, listType = null, filters = null, onExternalCodesChange, onSelectedCodeChange }) => {
	const [newCode, setNewCode] = useState("");
	const deleteMutation = useDeleteIntegrationCode(listType, filters);
	const selectedCodeLabel = selectedCode || "Sin código seleccionado";

	const handleAddCode = () => {
		const trimmedCode = newCode.trim();
		if (!trimmedCode || externalCodes.includes(trimmedCode)) return;

		onExternalCodesChange([...externalCodes, trimmedCode]);
		setNewCode("");
	};

	const handleDeleteCode = async (code) => {
		try {
			await deleteMutation.mutateAsync({ inventories: inventoryId, code, list_type: listType, filters });
			toast.success(`Código "${code}" eliminado correctamente`);
			onExternalCodesChange(externalCodes.filter((existing) => existing !== code));
			if (selectedCode === code) onSelectedCodeChange("");
		} catch {
			toast.error("Error al eliminar el código");
		}
	};

	return (
		<div className={styles.externalCodesContainer}>
			<div className={styles.inputRow}>
				<input
					type="text"
					value={newCode}
					onChange={(event) => setNewCode(event.target.value)}
					placeholder="Nuevo código externo"
					onKeyDown={(event) => {
						if (event.key === "Enter") {
							event.preventDefault();
							handleAddCode();
						}
					}}
					className={styles.codeInput}
				/>
				<CustomButton size="sm" variant="primary" onClick={handleAddCode} startIcon={<Plus size={14} />}>
					Agregar
				</CustomButton>
			</div>

			<p className={styles.codeStatus}>Código en uso: {selectedCodeLabel}</p>

			{externalCodes.length > 0 && (
				<div className={styles.codesTableWrapper}>
					<table className={styles.codesTable}>
						<thead>
							<tr>
								<th className={styles.codeHeaderCell}>Código externo</th>
								<th className={styles.codeHeaderCell}>Acción</th>
								<th className={styles.codeHeaderCell}>Eliminar</th>
							</tr>
						</thead>
						<tbody>
							{externalCodes.map((code, index) => {
								const isSelected = selectedCode === code;
								return (
									<tr key={index} className={`${styles.codeRow} ${isSelected ? styles.selected : ""}`}>
										<td className={styles.codeCell}>{code}</td>
										<td className={styles.actionCell}>
											<CustomButton
												size="sm"
												variant={isSelected ? "success" : "neutral"}
												onClick={() => onSelectedCodeChange(code)}
												startIcon={isSelected ? <Check size={12} /> : null}
											>
												{isSelected ? "Usando" : "Usar"}
											</CustomButton>
										</td>
										<td className={styles.deleteCell}>
											<CustomButton
												size="sm"
												variant="danger"
												onClick={() => handleDeleteCode(code)}
												disabled={deleteMutation.isLoading}
												startIcon={<Trash2 size={12} />}
											>
												Eliminar
											</CustomButton>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
			)}
		</div>
	);
};

export default IOExternalCodes;
